import _ from 'lodash';
import { useMemo } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { CollectionImage } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { JobVehicleRentClass, JobVehicleRentCurrency } from '~/shared';
import {
	setSelectedVehicle,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { menuTabsClassNames } from '../MenuTabs/MenuTabs.model';
import {
	StyledCarClassContainer,
	StyledCarName,
	StyledContainer,
	StyledDisabledContainer,
	StyledHead,
	StyledPriceContainer,
} from './Car.styled';

export type JobOwnedVehicleItem = {
	id: string;
	model: string;
	name: string;
	owned: true;
	enabled: boolean;
};

export type JobRentVehicleItem = {
	model: string;
	name: string;
	owned: false;
	enabled: boolean;
	level: number;
	price: number;
	priceCurrency: JobVehicleRentCurrency;
	class: JobVehicleRentClass;
};

const Car: React.FC<JobOwnedVehicleItem | JobRentVehicleItem> = (props) => {
	const dispatch = useLayoutDispatch();
	const selectedVehicle = useLayoutSelector(
		(state) => state.modal.selectedVehicle,
	);
	const isSelected = useMemo(
		() => _.isEqual(props, selectedVehicle),
		[selectedVehicle, props],
	);

	return (
		<StyledContainer
			$disabled={!props.enabled}
			$selected={isSelected}
			onClick={() => {
				dispatch(setSelectedVehicle(props));
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => {
				if (props.enabled) {
					playSound(Sound.LinkCursor);
				}
			}}
		>
			{(props as JobRentVehicleItem).level && !props.enabled && (
				<StyledDisabledContainer>
					<Text
						style={{ fontSize: '18px', color: '#FFFFFF' }}
						className={'disabled'}
					>
						<span style={{ fontWeight: 400 }}>Доступен на&nbsp;</span>
						<span style={{ fontWeight: 700 }}>
							{(props as JobRentVehicleItem).level}
						</span>
						<span style={{ fontWeight: 400 }}>&nbsp;ур.</span>
					</Text>
				</StyledDisabledContainer>
			)}
			<StyledHead>
				<StyledCarName>{props.name}</StyledCarName>
				{(props as JobRentVehicleItem).class && (
					<StyledCarClassContainer>
						<Text style={{ fontSize: '14px', fontWeight: 400 }}>
							{menuTabsClassNames[(props as JobRentVehicleItem).class]}
						</Text>
					</StyledCarClassContainer>
				)}
			</StyledHead>
			<CollectionImage collection={'vehicles'} id={props.model} size={96} />
			{(props as JobRentVehicleItem).price && (
				<StyledPriceContainer>
					<Text style={{ fontWeight: 400, opacity: 0.5 }}>Стоимость</Text>
					<Text>
						<span style={{ fontWeight: 700 }}>
							{(props as JobRentVehicleItem).price}
						</span>
						<span style={{ fontWeight: 400, opacity: 0.5 }}>&nbsp;₽ / ч.</span>
					</Text>
				</StyledPriceContainer>
			)}
		</StyledContainer>
	);
};

export { Car };
